module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/head-b9892478e19e01e1c9921edab52656db.png";